import React from "react";
import store from "../../../Store";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { toggleUserListFilter } from "./UserList-Actions";
import { unslufigy } from "../../../helpers/StringHelper";
import { Link } from "react-router-dom";
import Button from "../../../components/shared/buttons/Button";

class UserListFilters extends React.Component {
  componentDidMount() {}

  toggleFilter = (e) => {
    store.dispatch(toggleUserListFilter(e));
  };

  render() {
    let { title, params } = this.props;

    return (
      <div className="heading-block pr-60">
        <div className="title-block">
          <h2>{unslufigy(title)}</h2>
        </div>
        <div className="search-bar">
          <input
            type="text"
            className="form-control"
            name="q"
            placeholder={`Search ${unslufigy(title)}`}
            value={params.q}
            onChange={this.toggleFilter}
          />
          <span className="icon-search" />
        </div>
        <div className="button-wrapper">
          <Link to={`/allusers/create`}>
            <Button
              className="btn-theme btn-dark-blue"
              title={`Add User`}
              text={`Add User`}
            />
          </Link>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let { getUsers, userList } = state;
  let { params } = userList.data;

  return { getUsers, params };
}
export default withRouter(connect(mapStateToProps)(UserListFilters));
